import { useState,useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import Accordion from "@mui/material/Accordion";
import VoyageAccordion from "../ui/VoyageAccordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Label } from "abs-ui-components";
import { Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";

const ConsForm = ({ section, type, expandedId, setExpandedId }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const accordionRef2 = useRef(null);
	const accordionRefs = useRef([]);

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};

	const handleAccordionFocus = (event, accordionReference) => {
		if (
			accordionReference.current &&
			event.target === accordionReference.current
		) {
			// Simulate a click to toggle the accordion
			accordionReference.current.click();
		}
	};

	const handleAccordionsFocus = (event, accordionRef) => {
		if (
			accordionRef &&
			event.target === accordionRef
		) {
			// Simulate a click to toggle the accordion
			accordionRef.click();
		}
	};

	const fieldsBySubSection = section.fields.reduce((acc, field) => {
		if (!acc[field.subSection]) {
			acc[field.subSection] = [];
		}
		acc[field.subSection].push(field);
		return acc;
	}, {});


	return (
		<>
			{section.sectionName === "Fuel Consumption" && (
				<VoyageAccordion
					accordionId="CONS"
					expandedId={expandedId}
    				setExpandedId={setExpandedId}
					className="mt-4"
					onKeyDown={(event) => {
						if (event.key === "Tab") {
							handleAccordionFocus(event, accordionRef2);
						}
					}}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
						ref={accordionRef2}
					>
						<span className="voyage-form-headings">CONS</span>
					</AccordionSummary>
					<AccordionDetails>
						<MDBRow className="mt-0">
							{section?.fields?.map((formField, fieldIndex) => (
								<MDBCol
									md="3"
									className="pr-2 mt-3"
									key={`${formField.key}-${fieldIndex}`}
								>
									{formField.dataType === "decimal" && (
										<>
											<Label
												bold
												name={formField.fieldName}
												className="mb-1"
											/>
											<Controller
												name={
													formField.key
														? formField.key.replace(
															/\|/g,
															""
														) // Replace all pipes with an empty string
														: ""
												}
												control={control}
												defaultValue={
													type === "Edit"
														? formField.value ||
														null
														: ""
												}
												render={({ field }) => {
													// Ensure field is defined before accessing properties
													if (!field) return null; // Return null if field is undefined

													return (
														<Input
															autoFocus={false}
															{...field} // Spread the field props from Controller
															className="inputHeight"
															type="number"
															step="any"
															disabled={
																formField.isDisable
															}
															onChange={(e) => {
																field.onChange(
																	e
																);
															}}
															value={
																field?.value ??
																""
															} // Safely use field.value or fallback to ''
															onKeyDown={(e) => {
																preventScientificNotation(e);
																// Prevent up and down arrow keys
																if (
																	e.key === "ArrowUp" ||
																	e.key === "ArrowDown"
																) {
																	e.preventDefault();
																}
															}}
															onWheel={(e) => e.target.blur()}
														/>
													);
												}}
											/>
										</>
									)}
								</MDBCol>
							))}
						</MDBRow>
					</AccordionDetails>
				</VoyageAccordion>
			)}

			<>
				{(section.sectionName === "Consumer Fuel Consumption" || section.sectionName === "Consumer Fuel CO2") &&
					Object.keys(fieldsBySubSection).map((subSection, index) => (
						<VoyageAccordion key={subSection} accordionId={subSection} expandedId={expandedId} setExpandedId={setExpandedId} className="mt-4" onKeyDown={(event) => {
							if (event.key === "Tab") {
								handleAccordionsFocus(event, accordionRefs.current[index]);
							}
						}}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls={`panel-${index}-content`}
								id={`panel-${index}-header`}
								ref={(el) => (accordionRefs.current[index] = el)}
							>
								<span className="voyage-form-headings">
									{subSection}
								</span>
							</AccordionSummary>
							<AccordionDetails>
								<MDBRow className="mt-0">
									{fieldsBySubSection[subSection].map(
										(formField, fieldIndex) => (
											<MDBCol
												md="3"
												className="pr-2 mt-3"
												key={`${formField.key}-${fieldIndex}`}
											>
												{formField.dataType ===
													"decimal" && (
														<>
															<Label
																bold
																name={
																	formField.fieldName
																}
																className="mb-1"
															/>
															<Controller
																name={
																	sanitizeKey(formField.key)
																}
																defaultValue={
																	type === "Edit"
																		? formField.value ||
																		null
																		: ""
																}
																control={control}
																render={({
																	field,
																}) => (
																	<Input
																		{...field}
																		autoFocus={
																			false
																		}
																		className="inputHeight"
																		type="number"
																		step="any"
																		onChange={(
																			e
																		) =>
																			field.onChange(
																				e
																			)
																		}
																		value={
																			field?.value ??
																			""
																		}
																		onKeyDown={(e) => {
																			preventScientificNotation(e);
																			// Prevent up and down arrow keys
																			if (
																				e.key === "ArrowUp" ||
																				e.key === "ArrowDown"
																			) {
																				e.preventDefault();
																			}
																		}}
																		onWheel={(e) => e.target.blur()}
																	/>
																)}
															/>
														</>
													)}
											</MDBCol>
										)
									)}
								</MDBRow>
							</AccordionDetails>
						</VoyageAccordion>
					))
				}
			</>
		</>
	);
};

export default ConsForm;
